// extracted by mini-css-extract-plugin
export var filterIncDec = "_9c-0";
export var leftBorder = "_9c-1";
export var rightBorder = "_9c-2";
export var stringInput = "_9c-3";